import { render } from "./CheckBox.vue?vue&type=template&id=2d0345f5&scoped=true&ts=true"
import script from "./CheckBox.vue?vue&type=script&lang=ts"
export * from "./CheckBox.vue?vue&type=script&lang=ts"

import "./CheckBox.vue?vue&type=style&index=0&id=2d0345f5&scoped=true&lang=css"

import exportComponent from "C:\\Users\\luke\\Desktop\\poll_dashboard_new\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d0345f5"]])

export default __exports__